import React from "react";

function Error() {
    return <div>404 Error</div>;
}

export default Error;
